export default __webpack_public_path__ + "static/8-fir-d06bfc2147d89efab810806508126e33.png";